// extracted by mini-css-extract-plugin
module.exports = {"page":"Page-module--page--V2155","page__inner":"Page-module--page__inner--3xzwp","page__title":"Page-module--page__title--t1zKX","page__body":"Page-module--page__body--1A7TB"};